module.exports = __webpack_public_path__ + "img/SDC.d990e0ce.svg";